import { MessageResourceManager } from '../../../resources/message-resource-manager';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { EnvironmentConfiguration } from '@nts/std/src/lib/environments';
import { BaseError } from '../../../messages/base-error';
import { ComponentErrorInterface } from '../component-error.interface';
import { AuthService } from '../../../auth';
import { ChangeDetectorRef } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { FilledButtonComponent } from '../../shared/buttons/filled-button/filled-button.component';
import { NTSTranslatePipe } from '../../pipe/nts-translation-pipe';
import { TextButtonComponent } from '../../shared/buttons/text-button/text-button.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'nts-unauthorized-request',
    templateUrl: './unauthorized-request.component.html',
    styleUrls: ['./unauthorized-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        SvgIconComponent,
        FilledButtonComponent,
        NTSTranslatePipe,
        TextButtonComponent,
        NgIf,
    ]
})
export class UnauthorizedRequestComponent implements ComponentErrorInterface, OnInit {

    currentLogin = '';

    // popolata tramite injecton
    errors: BaseError[];
    errorTitle: string;
    errorDescription: string;
    errorDetailDescription: string;
    errorDetailMoreDescription: string;
    showDetailMore = false;
    expandDetailMore = false;
    showMoreLimit = 0; // 0 disabilitato

    constructor(
        public readonly environmentConfiguration: EnvironmentConfiguration,
        private readonly authService: AuthService,
        private readonly cd: ChangeDetectorRef
    ) {

    }
    async ngOnInit(): Promise<void> {
        const userProfile = await this.authService.getUserProfile();
        const tenantProfile = await this.authService.getTenantProfile();
        this.currentLogin = `${userProfile.name} ${userProfile.lastName}${tenantProfile?.businessName?.length > 0 ? ' (' + tenantProfile?.businessName + ')' : ''}`;

        this.errorTitle = MessageResourceManager.Current.getMessage('std_PageError401_Title');
        this.errorDescription = MessageResourceManager.Current.getMessage('std_PageError401_Description');
        this.errorDetailDescription = MessageResourceManager.Current.getMessageWithStrings('std_PageError401_DetailDescription', this.currentLogin);
        this.errorDetailDescription = MessageResourceManager.Current.getMessageWithStrings('PageError403_DetailDescription', this.currentLogin);
        if (this.errorDetailDescription.length > this.showMoreLimit && this.showMoreLimit > 0) {
            this.errorDetailMoreDescription = this.errorDetailDescription.substring(this.showMoreLimit, this.errorDetailDescription.length);
            this.errorDetailDescription = this.errorDetailDescription.substring(0, this.showMoreLimit);
            this.showDetailMore = true;
        }

        this.cd.detectChanges();
    }

    toggleShowMore(): void {
        this.expandDetailMore = !this.expandDetailMore;
    }

    logOut(): void {
        this.authService.logOut();
    }

}
